<template>
  <div class="inline-eta">
    <div class="upper-eta">
      <div
        class="eta"
      >{{ etaValue(0) }}
      </div>
    </div>
    <div
      v-if="lowerEtaDisplayed()"
      class="lower-eta"
    >
      <div class="eta">
        {{ etaValue(1) }}
      </div>
      <div class="eta">
        {{ etaValue(2) }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InlineEta",
  props: ['eta'],
  methods: {
    etaValue(i) {
      if (!this.eta[i]) {
        return "--";
      }

      if (this.eta[i].dis) {
        return `${this.eta[i].time} (${this.eta[i].dis}m)`;
      }

      return this.eta[i].time;
    },
    lowerEtaDisplayed() {
      return true;
    },
  },
}
</script>

<style scoped>
.eta {
  color: rgb(243, 69, 69);
}

.eta-notes {
  font-size: 0.85em;
}

.upper-eta {
  font-size: 1.2em;
}

.lower-eta > div {
  display: inline-block;
  width: 45%;
  overflow: hidden;
  white-space: nowrap;
}
</style>
